module.exports = __webpack_public_path__ + "img/home-spaceship.6197a74c.svg";